import React, { Component } from 'react'
import "../css/general-style.css"
import { AiFillPrinter } from "react-icons/ai"
import styles from '../pdfConfig/pdfInvoice'
import { Document, View, Page, Text, pdf } from '@react-pdf/renderer'
import { NumberFormat } from '../functions/generalFunctions'
import LoadingWindow from './LoadingWindow'


export class DownloadInvoicePDF extends Component {
    // eslint-disable-next-line
    constructor(props) {

        super(props)
        this.ModalLoading = React.createRef();
    }

    state = {
        showModal: false,
        lastRow: 0,


    }

    handleModalOpen = () => {
        this.setState({ showModal: true })
    }

    handleModalClose = () => {
        this.setState({ showModal: false })
    }




    calculateNewSheet() {
        let arrTam = this.props.bodyTable.length

        while (true) {
            arrTam = arrTam - 27
            if (arrTam <= 27) {
                break
            }
        }
        if (arrTam > 20) {
            return true
        }

        return false
    }

    truncDecimal(n) {
        let t = n.toString();
        let regex = /(\d*.\d{0,1})/;
        return t.match(regex)[0];
    }
    EncabezadoOrder(data, num) {
        let format = []
        let temporal = []
        let cont = 1

        for (const item of data) {
            if (cont === num) {
                temporal.push(item)
                format.push(temporal)
                temporal = []
                cont = 1

            } else {
                cont++
                temporal.push(item)
            }
        }

        return format
    }
    EncabezadoInfo(Llaves, State, Confirm) {

        let resultado = []
        Llaves.forEach(llave => {
            if (llave !== '$') {
                if (this.props.keysDecimalFormat.includes(llave) && State[llave] !== ' ') {
                    resultado.push(NumberFormat(Number(State[llave]).toFixed(2)))
                } else {
                    resultado.push(State[llave])
                }
            } else {
                if (Confirm) {
                    resultado.push(llave)
                } else {
                    resultado.push(' ')
                }



            }


        });


        return resultado
    }



    async generateDownolad() {
        await this.ModalLoading.current.showState(true);
        const blob = await pdf(
            <Document >
                <Page size="A4" wrap>
                    <View fixed>
                        <View style={styles.blockHeaderStyle}>
                            <View style={styles.blockHeader}>
                                <Text style={styles.CompanyTitleStyle}> {this.props.CompanyTitle}</Text>
                            </View>
                            <View style={styles.blockHeader}>
                                <Text style={styles.TypeInvoiceTitle}>{this.props.InvoiceType}</Text>
                            </View>
                            <View style={styles.PageInfoStyle}>
                                <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                                    `Page: ${pageNumber} / ${totalPages}`
                                )} />

                            </View>
                        </View>
                        <View style={styles.blockHeaderStyle}>
                            <View style={styles.block30Percent}>
                                {this.props.CompanyContactInfo.map((element, e) => (
                                    <Text key={e} style={styles.HeaderTextStyle}>{element}</Text>
                                ))}
                            </View>
                            <View style={styles.block70Percent}>
                                {this.EncabezadoOrder(this.props.InvoiceHeader, 2).map((element, e) => (
                                    <View style={styles.SubContainerHeader} key={e}>
                                        {
                                            element.map((element2, e2) => (
                                                (e2 === 0) ?
                                                    <View style={styles.ColumnaHeader1} key={e2}>
                                                        <Text >{element2}</Text>
                                                    </View>
                                                    :
                                                    <View style={styles.ColumnaHeader2} key={e2}>
                                                        <Text >{element2}</Text>
                                                    </View>
                                            ))
                                        }
                                    </View>
                                ))}
                            </View>
                        </View>
                        <View style={styles.blockHeaderStyle}>
                            <View style={styles.block50Percent}>
                                <Text style={styles.TitleBoxes1}>Sold To:</Text>
                            </View>
                            <View style={styles.block50Percent}>
                                <Text style={styles.TitleBoxes2}>Ship To:</Text>
                            </View>
                        </View>
                        <View style={styles.blockHeaderStyle}>
                            <View style={styles.BoxLeft}>
                                {
                                    this.props.Box1.map((element, e) => (
                                        <Text key={e} style={styles.TextStyleInHeaderBoxes}>{element}</Text>
                                    ))
                                }
                            </View>
                            <View style={styles.BoxRight}>
                                {
                                    this.props.Box2.map((element, e) => (
                                        <Text key={e} style={styles.TextStyleInHeaderBoxes}>{element}</Text>
                                    ))
                                }
                            </View>
                        </View>
                        <View style={styles.blockHeaderStyle}>
                            <View style={styles.TitleBoxes1}>
                                <Text style={styles.TextStyleInHeaderBoxes}>Confirm To:</Text>
                            </View>
                        </View>
                        <View style={styles.Table1Style}>
                            {
                                this.EncabezadoOrder(this.props.HeaderOptions, 4).map((element, e) => (
                                    <View key={e} style={styles.Table1File}>
                                        {

                                            element.map((element2, e2) => (
                                                <Text key={e2} style={styles.block22Percent}>{element2}</Text>
                                            ))}
                                    </View>


                                ))
                            }
                        </View>

                    </View>
                    <View style={styles.Table}>
                        <View fixed style={styles.CabeceraTabla}>
                            {
                                this.props.HeaderDescritpion.map((title, t) => (
                                    <Text style={styles[this.props.StyleDetail[t] + "Header"]} key={t}>{title}</Text>
                                ))
                            }
                        </View>
                        {
                            this.props.Detail.map((elemento, e) => (
                                (e + 1) < this.props.Detail.length && ((e + 1) % this.props.breakpoint !== 0) ?
                                    <View key={e} style={styles.CuerpoTabla}>{
                                        e % this.props.breakpoint === 0 && e !== 0 ?

                                            <View key={e} style={styles.FilaBreak}>{

                                                this.EncabezadoInfo(this.props.DescriptionKeys, elemento, (e + 1) <= this.props.quantSignDolar).map((fila, e2) => (
                                                    (e + 1) <= this.props.quantSignDolar ?
                                                        <View style={styles[this.props.StyleDetail[e2]]} key={e2}><Text key={e2}>{fila}</Text></View>
                                                        :
                                                        <View style={styles[this.props.StyleDetail[e2] + "Clear"]} key={e2}><Text key={e2}>{fila}</Text></View>
                                                ))
                                            }</View>



                                            :

                                            <View key={e} style={styles.Fila}>{
                                                this.EncabezadoInfo(this.props.DescriptionKeys, elemento, (e + 1) <= this.props.quantSignDolar).map((fila, e2) => (
                                                    (e + 1) <= this.props.quantSignDolar ?
                                                        <View style={styles[this.props.StyleDetail[e2]]} key={e2}><Text key={e2}>{fila}</Text></View>
                                                        :
                                                        <View style={styles[this.props.StyleDetail[e2] + "Clear"]} key={e2}><Text key={e2}>{fila}</Text></View>
                                                ))
                                            }</View>
                                    }
                                    </View>
                                    :
                                    <View key={e} style={styles.CuerpoTablaFinal}>{
                                        e % this.props.breakpoint === 0 && e !== 0 ?

                                            <View key={e} style={styles.FilaBreak}>{

                                                this.EncabezadoInfo(this.props.DescriptionKeys, elemento, (e + 1) <= this.props.quantSignDolar).map((fila, e2) => (
                                                    (e + 1) <= this.props.quantSignDolar ?
                                                        <View style={styles[this.props.StyleDetail[e2]]} key={e2}><Text key={e2}>{fila}</Text></View>
                                                        :
                                                        <View style={styles[this.props.StyleDetail[e2] + "Clear"]} key={e2}><Text key={e2}>{fila}</Text></View>
                                                ))
                                            }</View>



                                            :

                                            <View key={e} style={styles.Fila}>{
                                                this.EncabezadoInfo(this.props.DescriptionKeys, elemento, (e + 1) <= this.props.quantSignDolar).map((fila, e2) => (
                                                    (e + 1) <= this.props.quantSignDolar ?
                                                        <View style={styles[this.props.StyleDetail[e2]]} key={e2}><Text key={e2}>{fila}</Text></View>
                                                        :
                                                        <View style={styles[this.props.StyleDetail[e2] + "Clear"]} key={e2}><Text key={e2}>{fila}</Text></View>
                                                ))
                                            }</View>
                                    }
                                    </View>
                            ))
                        }


                        <View>
                            {this.EncabezadoOrder(this.props.bottomInformation, 11).map((element, e) => (
                                <View key={e} style={styles.CabeceraBottom}>
                                    {
                                        element.map((title, t) => (
                                            <Text style={styles[this.EncabezadoOrder(this.props.bottomStyle, 11)[e][t]]} key={t}>{title}</Text>
                                        ))
                                    }
                                </View>

                            ))}



                            <View style={styles.blockHeaderStyle}>
                                <Text style={styles.BottomTextStyle}>{this.props.bottomMessage}</Text>
                            </View>
                        </View>
                    </View>




                </Page>
            </Document>
        ).toBlob()
        let URL = window.URL.createObjectURL(blob);
        window.open(URL, '_blank');
        await this.ModalLoading.current.showState(false);
    }

    render() {
        return (
            <React.Fragment>
                <LoadingWindow ref={this.ModalLoading} />
                <div className="d-grid gap-2">
                    <button hidden={this.props.hidden} id={this.props.id} disabled={this.props.disabled} type="button" onClick={() => this.generateDownolad()} className={"btn " + this.props.colorButton + " btn-lg"}>{this.props.titleButton} <AiFillPrinter /></button>
                </div>

            </React.Fragment>
        )
    }
}

